module.exports = __webpack_public_path__ + "img/teams_icon.0abe436.svg";